import React, { memo, useState } from 'react'
import {
  Checkbox,
  FileUpload,
  Input,
  useTraversal,
} from '@guillotinaweb/react-gmi'
import { InputNumber } from 'antd'
import { message, Tabs } from 'antd'
import { I18NField } from '../../../components/i18nfield'
import { ProductSelector } from '../../../components/product-selector'
import { getCdnUrl, setLangs } from '../../../consts'

const Empty = () => null

export const OfferBannerForm = memo(({ selected, edit, langs }) => {
  const Ctx = useTraversal()
  const [uploading, setUploading] = useState(false)

  function onUploadBanner(lang) {
    return async (file) => {
      setUploading(true)
      const filename = `home/${Ctx.state.context['@name']}`
      const res = await Ctx.client.upload(Ctx.path, file, filename)

      if (res.status >= 300) {
        message.error('Error uploading the image')
        setUploading(false)
        return
      }

      const { path } = await res.json()
      const src = `/${path}`
      const image = selected.image || {}
      const isFirstImage = !Object.values(image).find((v) => v)

      edit('image', isFirstImage ? setLangs(src) : { ...image, [lang]: src })
      setUploading(false)
    }
  }

  return (
    <I18NField key={langs.join()} langs={langs} Widget={Empty}>
      {(lang) => (
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Image" key={`image-${lang}`}>
            <label className="label">Image</label>
            <FileUpload
              accept="image/*"
              onChange={onUploadBanner(lang)}
              label={uploading ? 'Uploading...' : 'Upload an image'}
            />
            {selected.image?.[lang] && (
              <img
                src={`${getCdnUrl()}${selected.image?.[lang]}`}
                alt="Banner preview"
              />
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Title, description & link"
            key={`text-button-${lang}`}
          >
            <label className="label">Title</label>
            <Input
              value={selected.title?.[lang] || ''}
              onChange={(v) => edit('title', { ...selected.title, [lang]: v })}
            />
            <label className="label">Short description</label>
            <Input
              value={selected.text_banner?.[lang] || ''}
              onChange={(v) =>
                edit('text_banner', { ...selected.text_banner, [lang]: v })
              }
            />
            <label className="label">Link</label>
            <Input
              value={selected.link?.[lang] || ''}
              onChange={(v) => edit('link', { ...selected.link, [lang]: v })}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Products & offer" key={`products-${lang}`}>
            <label className="label">Products</label>
            <ProductSelector
              id={selected.id}
              type="group"
              products={selected.query?.groups || []}
              onChange={(groups) => {
                if (groups.length > 2) {
                  return message.error(
                    'This section can show a maximum of 2 products.'
                  )
                }
                edit('query', { groups })
              }}
            />
            <label className="label mt10">Discount</label>
            <InputNumber
              min={0}
              max={100}
              value={selected.discount}
              onChange={(v) => edit('discount', v)}
            />
            <label className="label mt10">Discount text</label>
            <Input
              value={selected.discount_text?.[lang] || ''}
              onChange={(v) =>
                edit('discount_text', { ...selected.discount_text, [lang]: v })
              }
            />
            <Checkbox
              className="mt10"
              placeholder=" Is same offer for all products"
              value={selected.is_same_offer_for_all_products}
              onChange={(v) => edit('is_same_offer_for_all_products', v)}
            />
          </Tabs.TabPane>
        </Tabs>
      )}
    </I18NField>
  )
})
